export default __webpack_public_path__ + "resources/icons/d132-c404.png";